import * as actions from './actions';
import * as api from './api';
import reducer from './reducer';

const reducers = {
  accountWallet: reducer,
};

export { actions, api, reducers };
